// extracted by mini-css-extract-plugin
module.exports = {"page-header":"page-header__OrgGh","show-mobile":"show-mobile__2dCLW","title":"title__1gYcd","sub-title":"sub-title__3KY_j"};